@custom-media --mobile (max-width: 768px);

.browseContainer {
  margin-top: 1.5em;
}

.searchForm {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  @media (--mobile) {
    flex-direction: column;
  }
}
